import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Settings } from '../settings/settings';
import { Guest, Website, WeddingEvent } from '../website-builder/wedding';
import { GuestStateStore } from '../guest-list/guest.state.store';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { a, C } from '@angular/core/src/render3';
import { SettingsStateStore } from '../settings/settings.state.store';
@Component({
  selector: 'app-rsvp',
  templateUrl: './rsvp.component.html',
  styleUrls: ['./rsvp.component.scss']  
})
export class RsvpComponent implements OnInit {
  @Input() cssClass = '';
  @Input() website:Website;
  @Input() settings:Settings;
  @Input() groupedScheduleItems: any = [];
  @Input() previewEvent:WeddingEvent;
  @Input() preview = false;
  @Input() showModal = false;
  @Input() countryCode: string;
  @Output() closeModal = new EventEmitter<void>();
  searchName: string;
  rsvpGuestsSearch: Guest[];
  notFound = false;
  allEventNames: string[];
  showRsvpQuestions = false;
  currentRsvpGuest: Guest;
  currentEventIndex: number = 0;
  currentEvent: any;
  rsvpSubmitted: boolean;
  answeredPlusOne: boolean;
  weddingEventsForGuest: WeddingEvent[];
  currentPartyOfGuests : Guest[];
  respondedPartyOfGuests : Guest[];
  respondedToRsvp: boolean;
  guests: Guest[];
  displayPartyGroupList: boolean;
  @Input() viewingTranslatedMode: boolean;
  searching: boolean;
  submitting: boolean;
  allDeclined: boolean;
  partySizes: { [key: string]: number };
  constructor(
    private _guestState: GuestStateStore,
    private cdr: ChangeDetectorRef,
    private _websiteState: WebsiteStateStore,
    private _settingsStateStore: SettingsStateStore,
    private http: Http

  ) { }

  ngOnInit() {
    this._guestState.getState().subscribe(state => {
      this.guests = state.guests;
    })

    if(this.website && this.website.userId){
    this._settingsStateStore.getSettingsViaUserId(this.website.userId).subscribe(settings => {
      this.settings = settings;
      if(this.settings && this.settings.enableTranslations && this.settings.defaultLanguage!= "English"){
        this.viewingTranslatedMode = true;
      } 
    })
  }

    this._websiteState.tranlsationEmitted$.subscribe(tranlation => {
      
      this.viewingTranslatedMode = tranlation;
      if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges();      
     }
    });


if(this.previewEvent){
  this.currentEvent = this.previewEvent;
 // this.godModeForEvent(this.previewEvent);
  return;
}

  }

  addPlusOne(){
    
    this.answeredPlusOne = true
    let plusOneGuest = new Guest();
    plusOneGuest.firstName = this.currentRsvpGuest.plusOneFirstName
    plusOneGuest.lastName = this.currentRsvpGuest.plusOneLastName

 
    if(this.currentRsvpGuest.partyName){
      plusOneGuest.partyName = this.currentRsvpGuest.partyName;
    } else {
      plusOneGuest.partyName = this.currentRsvpGuest.id;
    } 
if(!this.currentRsvpGuest.partyName){
    this.currentRsvpGuest.partyName = this.currentRsvpGuest.id;
}
    plusOneGuest.email = this.currentRsvpGuest.email;
    plusOneGuest.rsvpStatus = this.currentRsvpGuest.rsvpStatus;
    plusOneGuest.rsvpResponses = this.currentRsvpGuest.rsvpResponses
    plusOneGuest.isPlusOneTo = this.currentRsvpGuest.id;
    if(!this.currentPartyOfGuests || this.currentPartyOfGuests.length == 0){
      this.currentPartyOfGuests = [];
    }
   this.currentRsvpGuest = plusOneGuest;
   this.answeredPlusOne = false;
   this.rsvpSubmitted = false;
   //remove host from currentPartyOfGuests

   this.updateGuest(this.currentRsvpGuest.id, this.currentRsvpGuest.firstName + ' ' + this.currentRsvpGuest.lastName, this.currentRsvpGuest.email);



   this.currentPartyOfGuests = this.currentPartyOfGuests.filter(g => g.id !==
      this.currentRsvpGuest.isPlusOneTo);
    
   
    this.clearRsvpFields();
    this.respondToRsvp(plusOneGuest);

  }

  updateGuest(websiteUserId: string, name: string, guestEmail: string) {
    const body = { websiteUserId, name, guestEmail };
    this.http.post(environment.firebase.clouldFunctionHost + '/updateGuest', body).subscribe(response => {
    }, error => {
    });
  }
  resetSearch(){
    this.currentRsvpGuest = null;
    this.currentEventIndex = 0;
    this.rsvpSubmitted = false;
    this.respondedToRsvp = false;
    this.currentPartyOfGuests = null;
    this.respondedPartyOfGuests = null;
    this.showRsvpQuestions = false;
    this.searchName = null;
    this.rsvpGuestsSearch = null;
    this.displayPartyGroupList = false;
    this.notFound = false;
  }

  close() {
    this.closeModal.emit();
    this.currentRsvpGuest = null;
    this.currentEventIndex = 0;
    this.rsvpSubmitted = false;
    this.respondedToRsvp = false;
    this.currentPartyOfGuests = null;
    this.respondedPartyOfGuests = null;
    this.showRsvpQuestions = false;
    this.searchName = null;
    this.rsvpGuestsSearch = null;
    this.displayPartyGroupList = false;
    this.notFound = false;
    this.searching = false;
  }

  closeRsvpModal() {
    this.currentRsvpGuest = null;
    this.currentEventIndex = 0;
    this.rsvpSubmitted = false;
    this.respondedToRsvp = false;
    this.currentPartyOfGuests = null;
    this.respondedPartyOfGuests = null;
    this.showRsvpQuestions = false;
    this.searchName = null;
    this.rsvpGuestsSearch = null;
    this.displayPartyGroupList = false;
    this.notFound = false;
    this.searching = false;
    this.showModal = false;
  }

  getPartySize(guest: Guest): number {
    return guest.partyName ? this.partySizes[guest.partyName] || 0 : 0;
  }

  nextEvent() {
    // Assuming currentEventIndex is the index of the current event in an array of events
  
    if (this.currentEventIndex < this.weddingEventsForGuest.length - 1) {
      this.currentEventIndex++;
      this.currentEvent = this.weddingEventsForGuest[this.currentEventIndex];
    } else {
      this.saveGuest();
    }
  }  
    showPartyList(guest:Guest){
    this.displayPartyGroupList = true;
    if(!this.currentPartyOfGuests && guest.partyName){
      this.currentPartyOfGuests  = this.guests.filter(g => g.partyName === guest.partyName);
      this.respondedPartyOfGuests = [];
    }
    
  
  }

 public godModeForEvent(event:WeddingEvent){
    this.currentEvent = event;  
    this.answeredPlusOne = true
    this.currentRsvpGuest = new Guest()
    this.currentRsvpGuest.firstName = 'Sample';
    this.currentRsvpGuest.lastName = 'Guest';
    this.currentRsvpGuest.rsvpStatus = {};
    this.currentRsvpGuest.rsvpStatus[event.id] = 'invited';
    this.currentRsvpGuest.rsvpResponses = {};

    this.clearRsvpFields();
    this.showRsvpQuestions=true;
    this.showModal = true;

    this.weddingEventsForGuest = [];



    this.weddingEventsForGuest.push(event);
    this.setRsvpStatus(event.id, 'attending');
  
  }
  extractDateOnly(originalDate: Date): Date {

  const year = originalDate.getFullYear();
  const month = originalDate.getMonth(); // Note: Months are zero-indexed
  const day = originalDate.getDate();

  // Create a new Date object with the extracted values
  const dateOnly = new Date(year, month, day);

  // Set the time to midnight to minimize timezone impact
  dateOnly.setHours(0, 0, 0, 0);

  return dateOnly;
}
  
  /**
   * Helper method to safely get translation option by index
   * Returns undefined if array doesn't exist or index is out of bounds
   */
  public getTranslationOption(translationArray: string[], index: number): string {
    if (!translationArray || !Array.isArray(translationArray) || index < 0 || index >= translationArray.length) {
      return undefined;
    }
    return translationArray[index];
  }

  checkEventAttandanceQuestionOptionsAndTranslationOptions(event :WeddingEvent){
    // Fix attendance question translations - only if options exist
    if (event.attendanceQuestion && event.attendanceQuestion.options && event.attendanceQuestion.options.length > 0) {
      // Initialize translation array if it doesn't exist
      if (!event.attendanceQuestion.optionsTranslation) {
        event.attendanceQuestion.optionsTranslation = [];
      }
      
      // For each option, ensure there's a corresponding translation
      event.attendanceQuestion.options.forEach((option, index) => {
        if (!event.attendanceQuestion.optionsTranslation[index]) {
          event.attendanceQuestion.optionsTranslation[index] = option;
        }
      });
    }
    
    // Fix RSVP question translations - only if options exist
    if (event.rsvpQuestions && event.rsvpQuestions.length > 0) {
      event.rsvpQuestions.forEach(question => {
        if (question.questionType === 'multi select' || question.questionType === 'yes/no') {
          if (question.options && question.options.length > 0) {
            // Initialize translation array if it doesn't exist
            if (!question.optionsTranslation) {
              question.optionsTranslation = [];
            }
            
            // For each option, ensure there's a corresponding translation
            question.options.forEach((option, index) => {
              if (!question.optionsTranslation[index]) {
                question.optionsTranslation[index] = option;
              }
            });
          }
        }
      });
    }
  }

  resetRsvp(event: WeddingEvent){
    this.currentRsvpGuest.rsvpStatus[event.id] = 'invited';
    this.currentRsvpGuest.rsvpResponses = {};
    this.currentEvent = event;
    this.cdr.detectChanges();

  }

  setPlusOneStatus(status: string): void {
    (this.currentRsvpGuest as any).plusOneStatus = status;
  }
  respondToRsvp(guest:Guest, isParty = false){
    this.currentRsvpGuest = guest;
    
    


   // if   this.currentRsvpGuest.rsvpStatus  is not null, iterate through the keys and null the values
    if(this.currentRsvpGuest.rsvpStatus){
      for(let key in this.currentRsvpGuest.rsvpStatus){
        let value =        this.currentRsvpGuest.rsvpStatus[key] 
        if (value == 'attending' || value == 'declined'){
        this.currentRsvpGuest.rsvpStatus[key] = 'invited';
        }
      }

    }
   
    
    this.displayPartyGroupList = false;
    // set allEventNames to the names of the events that the guest is invited to
    

    if(!this.currentPartyOfGuests && guest.partyName){
      this.currentPartyOfGuests  = this.guests.filter(g => g.partyName === guest.partyName);
      this.respondedPartyOfGuests = [];
    }
    

    
//populate weddingEventsForGuest with the events that the guest is invited to. To do this you must look at the guest.rsvpStatus and see if it is equal to 'invited' or 'attending' or 'declined'

this.weddingEventsForGuest = [];
this.weddingEventsForGuest = this.website.weddingEvents.filter(event => {
  
  if (event.startDate){
    event.startDate = new Date(this._websiteState.formatDateForCountry(event.startDate.toISOString(), this.countryCode))
  }
  if (event.startDateUtc && event.startDateUtc.year && event.startDateUtc.month && event.startDateUtc.day){
    event.startDate = new Date(event.startDateUtc.year, event.startDateUtc.month, event.startDateUtc.day);
  }
  if (event.endDate){
    event.endDate = new Date(this._websiteState.formatDateForCountry(event.endDate.toISOString(), this.countryCode))
  }
  if (event.endDateUtc && event.endDateUtc.year && event.endDateUtc.month && event.endDateUtc.day){
    event.endDate = new Date(event.endDateUtc.year, event.endDateUtc.month, event.endDateUtc.day);
  }
  let rsvpStatus = guest.rsvpStatus[event.id];
  return rsvpStatus === 'invited' || rsvpStatus === 'attending' || rsvpStatus === 'declined';
});

for(let event of this.weddingEventsForGuest){
  this.checkEventAttandanceQuestionOptionsAndTranslationOptions(event);
}


this.currentEventIndex = 0;
;
    this.answeredPlusOne = true;
    this.showRsvpQuestions=true;
    if(this.currentRsvpGuest.canBringPlusOne){
      this.answeredPlusOne = false;
    }

    if (this.currentRsvpGuest.canBringPlusOne && this.currentRsvpGuest.plusOneFirstName && this.currentRsvpGuest.plusOneLastName) {
      this.answeredPlusOne = true;

    } else {
      this.answeredPlusOne = false;
    }
    if (!this.currentRsvpGuest.rsvpResponses) {
      this.currentRsvpGuest.rsvpResponses = {};
      this.clearRsvpFields();
    }
    if(this.currentPartyOfGuests && this.currentPartyOfGuests.length > 0 && ((this.currentRsvpGuest.canBringPlusOne && this.answeredPlusOne ) || !this.currentRsvpGuest.canBringPlusOne ) ){
      let plusOnes = this.currentPartyOfGuests.filter(g => g.isPlusOneTo !== this.currentRsvpGuest.id);
      if(plusOnes && plusOnes.length > 0){
        this.answeredPlusOne = true;
        guest.plusOneFirstName = plusOnes[0].firstName;
        guest.plusOneLastName = plusOnes[0].lastName;
   
      }
    }
    this.currentEvent = this.weddingEventsForGuest[this.currentEventIndex];
    if(this.cdr){
      this.cdr.detectChanges();
      }
  }
  private clearRsvpFields() {
    for (let event of this.website.weddingEvents) {
      if (event.rsvpQuestions && event.collectRsvpsOnWebsite) {
        for (let question of event.rsvpQuestions) {
          this.currentRsvpGuest.rsvpResponses[question.id] = '';
        }
      }
    }
  }

  hasNotRSVPdYet(guest): boolean {
    return Object.values(guest.rsvpStatus).every(status => status === "invited" || status === "not-invited");
  }
  anyGuestSelected() {
    return this.rsvpGuestsSearch.some(guest => guest.selected);
  }

  searchGuest(searchName: string) {
    this.notFound = false;
    this.searching = true;
    this.submitting = false;
    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
    this.searchName = searchName;
    this._guestState.searchGuestApi(this.searchName, this.website.userId).then((response: any) => {
      this.rsvpGuestsSearch = response.guests;
      this.guests = response.allPartyGuests;
      
      this.partySizes = response.partySizes;
      console.log("PARTY SIZES", this.partySizes);
      if (this.rsvpGuestsSearch && this.rsvpGuestsSearch.length == 0) {
        this.notFound = true;
        this.searching = false;
        if (this.cdr && !this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
        return;
      }

      this.searching = false;
      if (this.cdr && !this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    });
  }

  
  
  editRsvp(guest:Guest){
    this.currentRsvpGuest = guest;
    this.showRsvpQuestions = true;
    this.currentEventIndex = 0;
    this.rsvpSubmitted = false;
  }
  submitRsvp(){
    this.showRsvpQuestions = true;
  }
  saveGuest(){
    this.submitting = true;
    
    (window as any ).grecaptcha.execute('6LeRGRUpAAAAAE7lY2q9SzI3OjafICtmjTzPEPyc', {action: 'submit'}).then((token)=> {

   
    


    // if(this.preview){
    //   this.close();
    //   return;
    // }
    

    if(this.currentRsvpGuest.id){
      


      //if all events are declined
      this.allDeclined = true;
      for(let key in this.currentRsvpGuest.rsvpStatus){
        if(this.currentRsvpGuest.rsvpStatus[key] !== 'declined'){
          this.allDeclined = false;
        }
      }

      if(this.allDeclined && this.currentRsvpGuest.canBringPlusOne){
        this.answeredPlusOne = true;
      }

    this._guestState.updateGuestViaApi(this.currentRsvpGuest, token);
    this.submitting = false;
    } else {
      let userId = this.website.userId;
      this._guestState.addGuestViaApi(this.currentRsvpGuest,userId, token);
      this.submitting = false;
    }
    // console.log( 'currentGuest', this.currentRsvpGuest);
    // console.log'answeredPlusOne' , this.answeredPlusOne);
    // if(this.currentRsvpGuest.canBringPlusOne &&  !this.answeredPlusOne ){
    //   this.rsvpSubmitted = true;
    //   this.currentRsvpGuest.plusOneFirstName = "";
    //   this.currentRsvpGuest.plusOneLastName = "";
    //   this.answeredPlusOne = false;
    //   this.submitting = false;
    //   this.cdr.detectChanges();
    //   return;
    // }
  if(this.currentPartyOfGuests && this.currentPartyOfGuests.length > 0 && ((this.currentRsvpGuest.canBringPlusOne && this.answeredPlusOne ) || !this.currentRsvpGuest.canBringPlusOne ) ){
      this.upsertIntoRespondedPartyOfGuests(this.currentRsvpGuest)
        this.currentPartyOfGuests = this.currentPartyOfGuests.filter(g => g.id !== this.currentRsvpGuest.id);
        let lastGuest = this.currentPartyOfGuests[0];
        if(lastGuest){
          this.currentEventIndex = 0;
          this.submitting = false;

        this.respondToRsvp(lastGuest)
        } 
        else {
          this.rsvpSubmitted = true;
          this.submitting = false;
          this.cdr.detectChanges();
        }
    } else {
      this.rsvpSubmitted = true;
      this.submitting = false;
      if(this.cdr){
      this.cdr.detectChanges();
      }
     this.upsertIntoRespondedPartyOfGuests(this.currentRsvpGuest)
    }
    
  });
  }
  areAllAnswersProvidedForCurrentEventForCurrentRsvpGuest(event: WeddingEvent): boolean {

    if(this.currentRsvpGuest.firstName && this.currentRsvpGuest.firstName.toLowerCase() == 'sample' && 
    this.currentRsvpGuest.lastName && this.currentRsvpGuest.lastName.toLowerCase() == 'guest'){
      return false;
    }

    let allAnswered = true;

    if (this.currentRsvpGuest.rsvpStatus[event.id] === 'declined') {
      return true;
    }

    if(this.currentRsvpGuest.rsvpResponses){

      if(event.rsvpQuestions){

        for (let question of event.rsvpQuestions) {
          if (!this.currentRsvpGuest.rsvpResponses[question.id] && !question.optional) {
            allAnswered = false;
          }
        }
    }
    }
    if(!this.currentRsvpGuest.rsvpStatus || this.currentRsvpGuest.rsvpStatus[event.id]==='invited'){
      allAnswered = false;
    }
    return allAnswered;
  }
  setRsvpStatus(eventId: string, status: string): void {
    this.currentRsvpGuest.rsvpStatus[eventId] = status;

    if(status === 'declined' ){
      // this.saveGuest();
      this.nextEvent();
    }
  }
  upsertIntoRespondedPartyOfGuests(guest:Guest){
    if(this.respondedPartyOfGuests && this.respondedPartyOfGuests.length > 0){
      let index = this.respondedPartyOfGuests.findIndex(g => g.id === guest.id);
      if(index > -1){
        this.respondedPartyOfGuests[index] = guest;
      } else {
        this.respondedPartyOfGuests.push(guest);
      }
    } else {
      this.respondedPartyOfGuests = [];
      this.respondedPartyOfGuests.push(guest);
    }
    
  }

  confirmGuest() {
    // Implement your confirmation logic here
  }
  isDifferentDate(startDate: Date, endDate: Date): boolean {
    if (!startDate || !endDate) return false;
    
    // Convert to Date objects if they're strings
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    return start.getFullYear() !== end.getFullYear() ||
           start.getMonth() !== end.getMonth() ||
           start.getDate() !== end.getDate();
  }
  updateResponse(weddingEventId: string, rsvpQuestionId: string, response: string) {
    const responseRsvp = { rsvpQuestionId, weddingEventId, response };
    // this.currentRsvpGuest.rsvpResponses = this.currentRsvpGuest.rsvpResponses || [];
    // this.currentRsvpGuest.rsvpResponses.push(responseRsvp);
    this._guestState.updateGuest(this.currentRsvpGuest);
  }

  getOptionText(originalText: string, translatedText: string): string {
    if (this.viewingTranslatedMode && translatedText) {
      return translatedText;
    }
    return originalText;
  }
}



// WEBPACK FOOTER //
// ./src/app/rsvp/rsvp.component.ts